import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import ChatListView from '@/views/ChatListView.vue'
import ChatView from '@/views/ChatView.vue'
import { authService } from '@/services/authService'
import { AppSettingsPendingError } from '@/services/appSettingsError'
import { useUserStore } from '@/stores/userStore'
import { toAppErrorDetails, useErrorStore } from '@/stores/errorStore'

const routes: RouteRecordRaw[] = [
	{
		path: '/',
		redirect: '/chat'
	},
	{
		path: '/chat',
		name: 'ChatList',
		component: ChatListView,
		meta: {
			title: 'Chaty',
			requiresAuth: true
		}
	},
	{
		path: '/chat/:channelId',
		name: 'Chat',
		component: ChatView,
		meta: {
			title: 'Chat',
			requiresAuth: true
		}
	},
	{
		path: '/error',
		name: 'Error',
		component: () => import('@/views/ErrorView.vue')
	},
	{
		path: '/profile-setup',
		name: 'ProfileSetup',
		component: () => import('@/views/ProfileSetup.vue')
	},
	{
		path: '/signin-callback',
		name: 'SignInCallback',
		component: () => import('@/views/SigninCallbackView.vue')
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: '/'
	}
]

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes
})

// guard
router.beforeEach(async (to) => {
	document.title = to.meta.title ? `${to.meta.title} | EUC` : 'EUC'

	// Check if route requires authentication
	if (to.meta.requiresAuth) {
		let token: string | null

		try {
			token = await authService.getAccessToken()
		} catch (error) {
			console.error('Auth check failed:', error)
			await authService.signIn()
			return false
		}

		if (!token) {
			await authService.signIn()
			return false
		}

		try {
			const userStore = useUserStore()
			await userStore.loadAppSettings(to.query)
		} catch (error) {
			if (error instanceof AppSettingsPendingError) {
				return { name: 'ProfileSetup', query: to.query, replace: true }
			}

			console.error('Application settings could not be loaded:', error)
			useErrorStore().setError(toAppErrorDetails(error))
			return { name: 'Error', replace: true }
		}
	}
})

export default router
